import { render, staticRenderFns } from "./ShoppingMallDeatil.vue?vue&type=template&id=229de0ff&scoped=true"
import script from "./ShoppingMallDeatil.vue?vue&type=script&lang=js"
export * from "./ShoppingMallDeatil.vue?vue&type=script&lang=js"
import style0 from "./ShoppingMallDeatil.vue?vue&type=style&index=0&id=229de0ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229de0ff",
  null
  
)

export default component.exports